<template>
  <generic-view :prepend="url" :steps="steps" not-numbered :loading="loading">
    <estime v-if="sas" :sasId="sas.id"></estime>
    <introduction v-show="step == 'introduction'" endpoint="demande-permis-psychotherapeute" @next-step="next"></introduction>
    <template v-if="sas">
      <div v-for="s in realSteps" :key="s.path">
        <div v-show="step == s.path">
          <headline :code="s.code"></headline>
          <component :is="s.path" :sas="sas" @validation-changed="setState(s.path, $event)" :ref="s.path">
            <ressource :code="s.code" />
          </component>
          <v-btn color="#3a3838" dark class="mt-6" x-large @click="next">Enregistrer et continuer</v-btn>
        </div>
      </div>
      <soumission v-show="step == 'soumission'" :showAlert="formulaireNonValide" @submit="submit" ref="soumission"></soumission>
    </template>
  </generic-view>
</template>

<script>
import Introduction from "@/components/FormParts/Introduction"
import Identification from "@/components/DemandePermisPsychotherapeute/Identification"
import MembreAutreOrdre from "@/components/DemandePermisPsychotherapeute/MembreAutreOrdre"
import Diplomes from "@/components/DemandePermisPsychotherapeute/Diplomes"
import Cours from "@/components/DemandePermisPsychotherapeute/Cours"
import Stages from "@/components/DemandePermisPsychotherapeute/Stages"
import DeclarationsJudiciaires from "@/components/FormParts/DeclarationsJudiciaires"
import Engagements from "@/components/DemandePermisPsychotherapeute/Engagements"
import Soumission from "@/components/FormParts/Soumission"
import FormulaireViewBase from "@/mixins/FormulaireViewBase"
import FormulaireBase from "@/mixins/FormulaireBase"
import Estime from "@/components/FormParts/Estime"

export default {
  mixins: [FormulaireViewBase, FormulaireBase],

  data() {
    return {
      url: "/demande-permis-psychotherapeute/",
      paramsName: "permis-psychotherapeute",
      loadPanierOnLoad: true,
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "identification", code: "titre-etape-1", state: "" },
        { path: "membre-autre-ordre", code: "titre-etape-2", state: "" },
        { path: "diplomes", code: "titre-etape-3", state: "" },
        { path: "cours", code: "titre-etape-4", state: "" },
        { path: "stages", code: "titre-etape-5", state: "" },
        { path: "declarations-judiciaires", code: "titre-etape-6", state: "" },
        { path: "engagements", code: "titre-etape-7", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    Introduction,
    Identification,
    MembreAutreOrdre,
    Diplomes,
    Cours,
    Stages,
    DeclarationsJudiciaires,
    Engagements,
    Soumission,
    Estime
  },

  metaInfo() {
    return {
      title: this.$i18n.t("meta.formulaires.title")
    }
  }
}
</script>

<style>
</style>
